// extracted by mini-css-extract-plugin
module.exports = {"host":"nav-search_host__qw7ys"};